'use client';
export {
  Separator,
  //
  Root,
} from './separator';
export type { SeparatorProps } from './separator';
